import LoadingOverlay from './LoadingOverlay.vue';

export default LoadingOverlay;
